import type { GeoStatus } from '../api/types';
import { geoStatusLabels, geoTone } from '../geo/labels';

export function GeoStatusBadge({ status }: { status: GeoStatus }) {
  return <span className={`badge badge-${geoTone(status)}`}>{geoStatusLabels[status] ?? status}</span>;
}
